import React from 'react'
// import little from '../little.png'


export default function Footer() {

    return (
        <>
            <div className="footer">
                <h2 id="footer-txt">
                    Built with React & Firebase by Aaron Gabriel
                </h2>
                {/* <img id="little" src={little} alt="" /> */}
            </div>
        </>
    )
}

